__turbopack_context__.v({
  "root": "pflsbG_root",
});
